'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxFooter = exports.BoxHeader = exports.BoxBody = exports.Box = undefined;

var _Box2 = require('./Box');

var _Box3 = _interopRequireDefault(_Box2);

var _Body = require('./Body');

var _Body2 = _interopRequireDefault(_Body);

var _Header = require('./Header');

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require('./Footer');

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Box = _Box3.default;
exports.BoxBody = _Body2.default;
exports.BoxHeader = _Header2.default;
exports.BoxFooter = _Footer2.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYm94L2luZGV4LmpzeCJdLCJuYW1lcyI6WyJCb3giLCJCb3hCb2R5IiwiQm94SGVhZGVyIiwiQm94Rm9vdGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O1FBQU9BLEc7UUFDQUMsTztRQUNBQyxTO1FBQ0FDLFMiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgQm94IGZyb20gJy4vQm94JztcbmV4cG9ydCBCb3hCb2R5IGZyb20gJy4vQm9keSc7XG5leHBvcnQgQm94SGVhZGVyIGZyb20gJy4vSGVhZGVyJztcbmV4cG9ydCBCb3hGb290ZXIgZnJvbSAnLi9Gb290ZXInO1xuXG4iXX0=